import { memo } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { GameCard } from './GameCard/GameCard';
import { GameCardSkeleton } from './GameCard/GameCardSkeleton';
import { CbTablePagination } from 'ui/components/CbTable/CbTablePagination';
import { GamesEmptyState } from '../../GamesEmptyState';
import { GameFilters, GamePaginationLabels, NormalizedGame } from 'types/Games';
import { useIsEmbedded } from 'providers';
interface GamesListProps {
  activeFilter: string;
  currentPage: number;
  games: NormalizedGame[];
  isMobile: boolean | undefined;
  isPending: boolean | undefined;
  managerView: boolean | undefined;
  numberOfRows: number;
  onPageChange: (pageNumber: number) => void;
  totalEntries: number;
}
export const GamesList = memo(({
  activeFilter,
  currentPage,
  games,
  isMobile,
  isPending,
  managerView = false,
  numberOfRows,
  onPageChange,
  totalEntries
}: GamesListProps) => {
  const {
    isEmbedded: isEmbeddedMode
  } = useIsEmbedded();
  return <Box>
        <Flex justifyContent="space-evenly" marginTop={2}>
          <Box width={{
        base: '100%'
      }} height="fit-content" minHeight="300px">
            {isPending ? <>
                <GameCardSkeleton marginBottom={4} />
                <GameCardSkeleton marginBottom={4} />
                <GameCardSkeleton marginBottom={4} />
              </> : games.length > 0 ? <>
                <Box height="100%">
                  <Box width="100%" gap={12} borderRadius="10px" display="flex" flexDirection="row" flexWrap="wrap" justifyContent="center" alignItems="baseline">
                    {games.map(game => <GameCard key={game.id} game={game} managerView={managerView} />)}
                  </Box>
                </Box>
                <Box marginTop={12} marginBottom={12}>
                  <CbTablePagination currentPage={currentPage} handlePageChange={onPageChange} isDarkMode={!isEmbeddedMode} label={GamePaginationLabels[activeFilter as GameFilters]} numberOfRows={numberOfRows} totalEntries={totalEntries} />
                </Box>
              </> : <GamesEmptyState activeFilter={activeFilter} isMobile={isMobile} managerView={managerView} />}
          </Box>
        </Flex>
      </Box>;
});